<script setup lang="ts">
import * as R from 'ramda'
import { computed } from 'vue'

import { useEvent } from '@desktop/views/Relation/composables'
import { EventRelatedStatuses } from '@desktop/views/Relation/Sports/configuration'
import { injectEventRelatedStatusConfig } from '@desktop/views/Relation/Sports/provide-inject'

import StatusesIncidents from './StatusesIncidents.vue'

// emits
type Emits = {
  click: []
}

defineEmits<Emits>()

// inject
const eventRelatedStatusConfig = injectEventRelatedStatusConfig()

// composables
const { event } = useEvent()

// computed
const eventStatusRelatedStatusesConfig = computed(() =>
  eventRelatedStatusConfig
    ? (R.prop(
        event.value.status_id,
        eventRelatedStatusConfig,
      ) as EventRelatedStatuses)
    : null,
)
</script>

<template>
  <div class="flex flex-col gap-y-4">
    <div class="text-lg font-bold">Statuses</div>
    <div
      v-if="eventStatusRelatedStatusesConfig"
      class="header-popover-scrollable-statuses flex flex-col gap-y-4"
    >
      <StatusesIncidents
        title="Possible next statuses"
        :eventRelatedStatusValues="
          eventStatusRelatedStatusesConfig.possibleNextStatusIncidents
        "
        @click="$emit('click')"
      />
      <StatusesIncidents
        title="Other"
        :eventRelatedStatusValues="
          eventStatusRelatedStatusesConfig.otherStatusIncidents
        "
        @click="$emit('click')"
      />
    </div>
    <div v-else>No possible next statuses</div>
  </div>
</template>
